<template>
  <div class="flex-center position-ref full-height">
    <div class="content">
      <div class="m-b-md">
        <h2 style="font-weight:bold">{{$t("school_name")}}</h2>

        <v-card style="min-width:400px;">
          <progress-bar :show="busy"></progress-bar>
          <form @submit.prevent="login" @keydown="form.onKeydown($event)">
            <v-card-title>
              <h3>{{ $t('login') }}</h3>
            </v-card-title>

            <v-card-text>
              <!-- Email -->
              <!-- <email-input
                :form="form"
                :label="$t('email')"
                :v-errors="errors"
                :value.sync="form.email"
                name="email"
                prepend="person_outline"
                v-validate="'required|email'"
              ></email-input> -->

              <text-input
                :form="form"
                label="Email/Phone"
                :v-errors="errors"
                :value.sync="form.email"
                name="email"
                prepend="person_outline"
                v-validate="'required'"
              ></text-input>

              <!-- Password -->
              <password-input
                :v-errors="errors"
                :form="form"
                :value.sync="form.password"
                prepend="lock_outline"
                v-validate="'required|min:8'"
              ></password-input>

              <!-- Remember Me -->
              <v-checkbox
                :label="$t('remember_me')"
                color="primary"
                type="checkbox"
                v-model="remember"
                value="true"
              ></v-checkbox>

              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <router-link :to="{ name: 'password.request' }">{{ $t('forgot_password') }}</router-link>
                  <!-- <a href>Forgot Password</a> &nbsp
                  <a href>Register</a>-->
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <submit-button :block="true" :form="form" :label="$t('login')"></submit-button>
                </v-flex>
              </v-layout>
            </v-card-text>
            <!-- <v-card-actions>
              <!-- <router-link :to="{ name: 'register' }">
              {{ $t('register') }}
              </router-link>--
              <v-spacer></v-spacer>
              <router-link :to="{ name: 'password.request' }">{{ $t('forgot_password') }}</router-link>
            </v-card-actions>-->
          </form>
        </v-card>
        <h5>
          &copy SchoolGP v1.5 by
          <a href="mailto:gopear.technologies@gmail.com">GoPear Technologies</a>
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "vform";
import { mapGetters } from "vuex";

export default {
  name: "admin-login-view",
  // metaInfo() {
  //   return { title: "Back-Office Login" };
  // },
  data: () => ({
    form: new Form({
      email: "",
      password: ""
    }),
    eye: true,
    remember: false,
    busy: false
  }),
  computed: {
    ...mapGetters({
      user: "authUser"
    })
  },
  mounted() {
    this.$store.dispatch("logout");
  },
  methods: {
    async login() {
      if (await this.formHasErrors()) return;
      this.busy = true;

      // Submit the form.
      const { data } = await this.form.post("/api/login");

      // Save the token.
      this.$store.dispatch("saveToken", {
        token: data.token,
        remember: this.remember
      });

      // Fetch the user.
      await this.$store.dispatch("fetchUser");
      this.busy = false;

      //console.log(user)
      if (this.user.status == 0) {
        this.$store.dispatch("responseMessage", {
          type: "error",
          text: "Sorry your account is disabled. Kindly contact administrator.",
          title: "Back-Office Login",
          modal: false
        });
        await this.$store.dispatch("logout");
        return;
      }
      let user_roles = this.user.roles;

      if (user_roles) {
        for (var i = 0; i < user_roles.length; i++) {
          if (user_roles[i].name == "administrator") {
            this.$router.push(this.$route.query.redirect || "/admin");
            break;
          } else if (user_roles[i].name == "accountant") {
            this.$router.push(this.$route.query.redirect || "/accountant");
            break;
          } else if (user_roles[i].name == "teacher") {
            this.$router.push(this.$route.query.redirect || "/teacher");
            break;
          } else if (user_roles[i].name == "guardian") {
            this.$router.push(this.$route.query.redirect || "/guardian");
            break;
          } else {
            this.$store.dispatch("responseMessage", {
              type: "error",
              text: "Sorry your account is unauthorized for this request.",
              title: "Back-Office Login",
              modal: false
            });
            await this.$store.dispatch("logout");
            break;
          }
        }
      }

      // Redirect home.
      //this.$router.push({ name: 'home' })
    }
  }
};
</script>


<style scoped>
.full-height {
  height: 100vh;
}

.flex-center {
  align-items: center;
  display: flex;
  justify-content: center;
}

.position-ref {
  position: relative;
}

.top-right {
  position: absolute;
  right: 10px;
  top: 18px;
}

.content {
  text-align: center;
}

.title {
  font-size: 60px;
}

.links > a {
  color: #636b6f;
  padding: 0 25px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1rem;
  text-decoration: none;
  text-transform: uppercase;
}

.m-b-md {
  margin-bottom: 30px;
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/adminlogin.vue